/**
 * @module app.shared
 */

import { convertToStringArray, convertToString } from 'app/shared/lib/utilities';

export class SplitLinesValueConverter {

    /**
     * Split the specified `value` on `CRLF`, `CR`, or `LF` characters.
     *
     * * If `value` is `null` or `undefined`, and empty array is returned.
     * * If `value` is an array, it is simply converted to a `string[]` and returned.
     * * Otherwise, `value` is converted to a `string` and split into a `string[]`.
     *
     * @param value the value to split
     */
    public toView(value: unknown): string[] {
        if(value === undefined || value === null) { return []; }

        if(Array.isArray(value)) { return convertToStringArray(value, true); }

        const text = convertToString(value);
        return text.split(/\r\n|\r|\n/);
    }

}

export class FormatValueConverter {

    public toView(value: unknown, format: unknown): string | null {
        if(value === null || value === undefined || !format) { return null; }

        let values: any[];
        if(Array.isArray(value)) { values = value; }
        else { values = [value]; }

        const formatString = convertToString(format);
        return formatString.replace(/\$([0-9]+)/g, (match, capture) => values[parseInt(capture, 10)] || '');
    }

}

/**
 * Replaces text in a string.
 */
export class ReplaceValueConverter {
    public toView(value: string, from: string, to: string): string {
        return value.replace(new RegExp(from, 'g'), to);
    }
}

/**
 * Trims a string from the first occurrence of the "trimFrom" string.
 */
export class TrimAfterValueConverter {
    public toView(value: string, trimFrom: string): string {
        const trimIndex = value.indexOf(trimFrom, 0);

        return (trimIndex < 0) ? value : value.substring(0, trimIndex);
    }
}
